import { DateTime } from 'luxon';
import { isOvernightTimeRange } from './is-overnight-time-range';

export const getTimeRangeEndDatetime = (
  date: string,
  startTime: string,
  endTime: string
): DateTime => {
  const endDate = isOvernightTimeRange(startTime, endTime)
    ? DateTime.fromISO(date).plus({ days: 1 })
    : DateTime.fromISO(date);

  return DateTime.fromISO(`${endDate.toISODate()}T${endTime}`);
};
